import type { SVGProps } from "react";
const SvgAqsati = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 372 372"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="#1e8fba"
      d="M38.1 306.9C8.1 262.3.7 214.7 22.6 165.8c23.4-52.1 65.6-79.3 123-81.4 7.4-.2 14.7 1 22 1.4 4.4.2 6.5 2.4 7.9 6.7a275 275 0 0 1 13.7 78.9l-.2 3.2c-6.9-2.2-13.5-4.8-20.3-6.4-23.8-5.5-51 1.1-66.2 24a53 53 0 0 0-7.3 42 57 57 0 0 0 40.8 45.3c22 6.8 46-2 60-20.4 12.2-16 17.9-34.5 19.9-54.2q2.7-27.9-1.3-55.8c-.3-2.7.3-4.1 2.6-5.7l59.8-39.8 10-6.4 1.5 7.1c7 45.3 9.5 90.6.6 136a177 177 0 0 1-24.2 63 130 130 0 0 1-71.2 54.8 135 135 0 0 1-111.7-12c-17.4-9.7-31.7-23-43.9-39.2"
    />
    <path d="M297.2 265a275 275 0 0 0 11-82.7q-.2-13.4.7-27l8.5 23.6q22 61.2 44.3 122.4c1.7 4.6.9 6.8-3.3 9.5q-30 19.6-60 39.6l-8.2 5-2.2-5q-6.1-16.9-12-33.9c-.6-2-.2-4.9.9-6.7 8.3-14 15.4-28.7 20.3-44.7M216.1 44c-4.6 3.5-9 7.3-7 13.4 2 5.7 7.7 6.3 12.9 6.8a50 50 0 0 0 27.3-6.1q6-3.2 12-6c6.7-3 13.8-1 17.8 4.6 3.4 4.6 2.8 13.4-1.5 18q-3 3-6.7 5.2c-13.5 9.3-27.4 18.2-40.6 28-5 3.6-8.7 9-12.7 13.9-4.3 5.2-7.9 6.8-12.3 4.8-4.3-2-6.4-6.2-4.4-12.4 2-6 5.4-11.7 8.1-17.6q.6-1.1.8-2c-5-2.5-10.6-4.2-14.9-7.5-8.8-7-10.3-17.3-10-28 .7-21 16.4-42.5 35.7-48.6 8.2-2.6 16.1-2.7 23.2 3q7.2 6 4.9 14.8c-1.4 5.6-5.4 8.9-11.1 10.2Q227 40.9 216 44" />
  </svg>
);
export default SvgAqsati;
